<template>
  <v-container class="box-container ma-0 pa-0">
    <v-col cols="12" justify="center" class="row-content ma-0 pa-0 px-4" style="max-width: 400px">
      <v-switch class="row-header ma-0 pa-0 mt-4 mx-4" density="compact" hide-details v-model="IF.DarkMode" :color="Colors.IconColor">
        <template v-slot:label>
          <span :class="IF.MyFont">Тъмен режим</span>
        </template>
      </v-switch>
      <v-switch class="row-header ma-0 pa-0 mx-4" density="compact" hide-details v-model="IF.Dense" :color="Colors.IconColor">
        <template v-slot:label>
          <span :class="IF.MyFont">Свити таблици</span>
          <v-menu open-on-hover activator="parent">
            <v-card>
              <v-data-table hide-default-footer :density="IF.Density">
                <thead>
                  <tr>
                    <th>{{ "Заглавие 1" }}</th>
                    <th>{{ "Заглавие 2" }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ "Колона 1" }}</td>
                    <td>{{ "Колона 2" }}</td>
                  </tr>
                </tbody>
              </v-data-table>
            </v-card>
          </v-menu>
        </template>
      </v-switch>
      <v-switch class="row-header ma-0 pa-0 mx-4" density="compact" hide-details v-model="IF.ShowSums" :color="Colors.IconColor">
        <template v-slot:label>
          <span :class="IF.MyFont">Дневен оборот в текущо състояние</span>
        </template>
      </v-switch>
      <v-tooltip location="right" style="z-index: 10">
        <template v-slot:activator="{ props }">
          <v-switch class="row-header ma-0 pa-0 mx-4" density="compact" hide-details v-model="IF.ShowTooltips" :color="Colors.IconColor">
            <template v-slot:label>
              <span v-bind="props" :class="IF.MyFont">Показвай балони</span>
            </template>
          </v-switch>
        </template>
        <span>Примерен балон</span>
      </v-tooltip>

      <v-slider class="row-header ma-0 pa-0 mx-4" :min="1" :max="3" :step="1" density="compact" hide-details v-model="IF.Font" :thumb-label="!hideTooltips">
        <template v-slot:label>
          <span :class="IF.MyFont">Шрифт</span>
        </template>
      </v-slider>

      <v-divider class="row-header"></v-divider>

      <v-row class="mа-2 pa-3 py-5">
        <t-btn :disabled="isSaveDisabled" class="ma-1 pa-2" @click="saveUserSettings()">
          <v-icon size="20">mdi-checkbox-marked-circle-outline</v-icon>
          <span> Запис </span>
        </t-btn>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import { g_Dialog } from "@/main";
import HTTPSender from "@/js/HTTPSender";
export default {
  components: {},
  data() {
    return {
      isSaveDisabled: false,
    };
  },
  methods: {
    async setMeta(meta, err) {
      this.datatype = meta.datatype;
      this.$refs.refGridClients.setMeta(meta, err);
      // this.clients = DataManager.getData(this.datatype);
      // this.datatype.isLoading = true;
      if (err.success && !err.message) {
        //TODO
      }
      this.datatype.isLoading = false;
    },

    saveUserSettings() {
      this.isSaveDisabled = true;
      var obj = {
        settings1: JSON.stringify({
          Font: this.IF.Font,
          DarkMode: this.IF.DarkMode,
          Density: this.IF.Density,
          ShowTooltips: this.IF.ShowTooltips,
          ShowSums: this.IF.ShowSums,
          MultiSort: this.IF.MultiSort,
          StartPage: this.IF.StartPage,
        }),
      };
      g_Dialog
        .show(g_Dialog.dialog_types.loader, null, {
          message: "Запис на настройките, моля изчакайте...",
        })
        .then(() => {
          HTTPSender.SendPOSTreq(JSON.stringify(obj), "EVUser/UpdateCpuser/")
            .done((res) => {
              g_Dialog.close();
              if (res.success) {
                g_Dialog.showInfo("Успешен запис.");
              } else {
                g_Dialog.showError("Грешка при запис на настройки!\n" + (res.err ? res.err.message : ""));
              }

              setTimeout(() => {
                this.isSaveDisabled = false;
              }, 3000);
            })
            .fail((err) => {
              g_Dialog.close();
              console.log("fail");
              console.log(JSON.stringify(err));
              setTimeout(() => {
                this.isSaveDisabled = false;
              }, 3000);
            });
        });
    },
  },
  computed: {},
};
</script>

<style lang="css" scoped>
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>